
import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { EEventType } from "src/app/domain/enums/eventType";
import { UserDTO } from "./user.dto";
import { InterventionDTO } from "./intervention.dto";

export class EventDTO {

    @AutoMap()
    code!: string;
    @AutoMap()
    type!: EEventType;
    @AutoMap()
    from!: string;
    @AutoMap()
    to!: string;
    @AutoMap()
    titre?: string;
    @AutoMap()
    description?: string;

    @AutoMap(() => [UserDTO])
    sampler: UserDTO = new UserDTO();

    @AutoMap(() => [InterventionDTO])
    intervention: InterventionDTO = new InterventionDTO();

    public constructor(init?: Partial<EventDTO>) {
        Object.assign(this, init);
    }
}